import { observer } from 'mobx-react';
import React from 'react';
import SGMSClient from '../../js/SGMSClient';
import { store } from '../../stores/store';
import './MeetingOverlayPopup.css';

const MeetingOverlayPopup = () => {
  let periodState =  SGMSClient.sequenceManager.periodState

  if(periodState === "PERIOD_STARTED") return null


  let msgId
  if(periodState === "PERIOD_PAUSED") msgId = "meeting_paused"
  else if(periodState === "PERIOD_STOPPED" || periodState === "SEQUENCE_STOPPED" || periodState === "SEQUENCE_FINISHED") msgId = "meeting_finished"
  else {
    msgId = "meeting_not_started"
  }
  return (
    <div className="MeetingOverlayPopup">
      <span>{store.t(msgId)}</span>
    </div>
  );
};

export default observer(MeetingOverlayPopup)
